export default __webpack_public_path__ + "static/media/02_ copy.5c815548.png";